(function () {
  if (window.__shippingRatesInit) return;
  window.__shippingRatesInit = true;

  const config = window.shippingRatesConfig || {};
  const cartBase = (window.routes && window.routes.cart_url) || '/cart';

  const POLL_INTERVAL = 500;
  const POLL_MAX_ATTEMPTS = 20;

  let requestToken = 0;

  function formatEuro(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function buildQuery() {
    const params = new URLSearchParams();
    params.set('shipping_address[zip]', config.zip || '');
    params.set('shipping_address[country]', config.country || '');
    if (config.province) params.set('shipping_address[province]', config.province);
    return params.toString();
  }

  function getCartState(totals) {
    const node = totals.querySelector('[data-cart-total]');
    if (!node) return null;
    return {
      totalCents: parseInt(node.dataset.cartTotal, 10) || 0,
      itemCount: parseInt(node.dataset.cartItemCount, 10) || 0,
    };
  }

  function getTotalsBlocks() {
    return Array.from(document.querySelectorAll('.totals')).filter((totals) => {
      const state = getCartState(totals);
      return state && state.itemCount > 0;
    });
  }

  function setLoading(isLoading) {
    getTotalsBlocks().forEach((totals) => {
      totals.querySelectorAll('.loading__spinner').forEach((spinner) => {
        spinner.classList.toggle('hidden', !isLoading);
      });
    });
  }

  function applyRate(rate) {
    // Transporträder: keine Versandkosten überschreiben
    if (document.querySelector('[data-pickup-only="true"]')) return;

    getTotalsBlocks().forEach((totals) => {
      const state = getCartState(totals) || {};
      const subtotalCents = state.totalCents || 0;
      const shippingNode = totals.querySelector('[data-shipping-price]');
      const estimatedNode = totals.querySelector('[data-estimated-price]');

      // Vollen Produktpreis direkt vom totals-Element lesen (vor Anzahlung-Rabatt)
      const fullCartValue = parseInt(totals.dataset.fullCartValue, 10) || subtotalCents;
      const correctedShipping = fullCartValue >= 29800 ? 2995 : 495;

      if (shippingNode) shippingNode.textContent = formatEuro(correctedShipping);
      if (estimatedNode) estimatedNode.textContent = formatEuro(subtotalCents + correctedShipping);
    });
  }

  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function pollRates(query, token) {
    const url = `${cartBase}/async_shipping_rates.json?${query}`;
    for (let attempt = 0; attempt < POLL_MAX_ATTEMPTS; attempt++) {
      if (token !== requestToken) return null;
      const response = await fetch(url);
      const data = await response.json();
      if (data !== null) {
        return Array.isArray(data) ? data : data.shipping_rates || [];
      }
      await delay(POLL_INTERVAL);
    }
    return null;
  }

  function cartIsEmpty(event) {
    const count = event && event.cartData && event.cartData.item_count;
    if (typeof count === 'number') return count === 0;
    if (event) return false;
    return getTotalsBlocks().length === 0;
  }

  async function refresh(event) {
    if (cartIsEmpty(event)) return;

    const token = ++requestToken;
    const query = buildQuery();
    setLoading(true);

    try {
      await fetch(`${cartBase}/prepare_shipping_rates.json?${query}`, { method: 'POST' });
      if (token !== requestToken) return;

      const rates = await pollRates(query, token);
      if (token !== requestToken) return;

      if (rates && rates.length) applyRate(rates[0]);
    } catch (error) {
      console.error('[shipping-rates]', error);
    } finally {
      if (token === requestToken) setLoading(false);
    }
  }

  function init() {
    refresh();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => refresh(event));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
